import { Button, Col, Container, Row } from '@microfrontends/react-components'
import { useRouter } from 'next/router'
import { useContext } from 'react'
import Industry from '../../../components/NumerologyV2/Industry'
import AppContext from '../../../context/AppContext'
import { IDataChartNumerology } from '../../../services/numerology/@type'
import { Box } from '../../NumerologyContainerV2/Numerology.css'

interface IProps {
	rulingNumber: number | null
	descriptionPersonalities: string | null
	rulingNumberJobs: IDataChartNumerology[]
}
export default function TopJobs({
	rulingNumber,
	descriptionPersonalities,
	rulingNumberJobs
}: IProps) {
	const { t } = useContext(AppContext)
	const router = useRouter()
	return (
		<Container>
			<Row>
				<Col>
					<Industry
						rulingNumberJobs={rulingNumberJobs}
						rulingNumber={rulingNumber}
						descriptionPersonalities={
							descriptionPersonalities ?? ''
						}
					/>
				</Col>

				<Box className='center'>
					<Button
						type='primary'
						className='search_button'
						onClick={() => {
							router.push(`${t('/career-path')}`)
						}}
						style={{ margin: '20px 0 35px 0' }}
					>
						{t('Tra cứu các hành trình sự nghiệp khác')}
					</Button>
				</Box>
			</Row>
		</Container>
	)
}
